<template>
  <BittsModal
    :visible="true"
    :aria-label="`Reject ${count} seat ${requestsLabel}`"
    :action-loading="isRejecting"
    variant="confirm"
    primary-button-text="Reject"
    primary-button-type="danger"
    secondary-button-text="Cancel"
    @action="emit('confirm')"
    @closed="emit('close')"
  >
    <template #image>
      <div class="seat-request-bulk-reject-modal__icon">
        <FontAwesomeIcon :icon="['fak', 'delete']" />
      </div>
    </template>
    <template #header>
      <div class="flex flex-col items-center">
        <h3
          class="text-xl font-bold text-neutral-text-strong text-center w-full mb-8"
        >
          {{ `Reject ${count} seat ${requestsLabel}` }}
        </h3>
        <p class="text-neutral-text text-center">
          {{ description }}
        </p>
      </div>
    </template>
  </BittsModal>
</template>

<script setup lang="ts">
import { BittsModal } from '@crossbeam/bitts';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { pluralize } from 'humanize-plus';
import { computed } from 'vue';

const { count, isRejecting = false } = defineProps<{
  count: number;
  isRejecting?: boolean;
}>();

const emit = defineEmits<{
  confirm: [];
  close: [];
}>();

const requestsLabel = computed(() => pluralize(count, 'request'));
const description = computed(
  () =>
    `This will decline ${count} seat ${requestsLabel.value}. The ${pluralize(count, 'requester')} won't be added to Crossbeam.`,
);
</script>

<style scoped lang="pcss">
@reference "../../../css/theme.css";
.seat-request-bulk-reject-modal__icon {
  @apply flex items-center justify-center rounded-full w-120 h-120 mb-8
    bg-top-gradient from-danger-accent/20 to-danger-accent/0 text-danger-accent text-[4rem];
}
</style>
